import { useEffect, useRef, useState } from 'react';
import { ConfirmDialog } from '../../../../../component/ConfirmDialog';
import CustomIconButton from '../../../../../component/custom-icon-button/CustomIconButton';
import { TableCustomHeader } from '../../../../../component/table/components/TableCustomHeader';
import { TableCustom } from '../../../../../component/table/table-custom/TableCustom';
import { useKeVatTuContext } from '../../context';
import { useTableSelectVatTuContext } from '../../context/TableSelectVatTuContext';
import { columnsPhieuChiDinhKeVatTu } from '../../../../../phan-he-kham-benh/columns/modal-ke-vat-tu/ColumnModalKeVatTu';
import { getIndexedDBItem } from '../../../../../utils/IndexedDB';
import { KEY_DS_DANH_MUC_TIEP_DON } from '../../../../../utils/Constant';
import { getCellEditValue } from '../../../../../phan-he-kham-benh/modals/modal-ke-vat-tu/common';
import { usePhanHeDieuTriNoiTruContext } from '../../../../PhanHeDieuTriContext';

const TablePhieuChiDinhVatTu = () => {
	const { vatTuChecked, setVatTuChecked, setDeletedList } = useKeVatTuContext();
	const { setSelectedRow, setEditRowIndex } = useTableSelectVatTuContext();
	const { benhNhanDieuTri } = usePhanHeDieuTriNoiTruContext();

	const rowSelectedRef = useRef<any>();
	const [openCofirmDeleteDialog, setOpenCofirmDeleteDialog] = useState<boolean>(false);
	const [categories, setCategories] = useState({
		listDoiTuong: [],
	});	

	useEffect(() => {
		getCategories();
	}, []);

	const getCategories = async () => {
		try {
			const response = await getIndexedDBItem(KEY_DS_DANH_MUC_TIEP_DON);
			setCategories(response);
		} catch (error) {
			console.error(error);
		}
	};

	const onDeleteVatTu = () => {
		if (rowSelectedRef.current.idBackend) {
			setDeletedList(rowSelectedRef.current.idBackend, {
				...rowSelectedRef.current,
				deleted: true,
			});
		}
		const listTemp = vatTuChecked.filter((row) => (row.id !== rowSelectedRef.current.id || row?.consignment !== rowSelectedRef.current?.consignment));
		setVatTuChecked(listTemp.map((row, index) => ({ ...row, index })));
		setOpenCofirmDeleteDialog(false);
	};

	const columnsActions = {
		Header: (props: any) => (
			<TableCustomHeader
				tableProps={props}
				title="Thao tác"
				className="text-center text-light min-w-80px"
			/>
		),
		id: 'actions',
		Cell: ({ ...props }) => (
			<div className="d-flex justify-content-center">
				<CustomIconButton
					variant="edit"
					onClick={() => {
						const rowData = props.row.original;
						setEditRowIndex(props.row.index);
						setSelectedRow({
							...rowData,
							id: rowData?.idVatTu?.toString() || rowData?.id,
						});
					}}
				>
					<i className="bi bi-pencil-square text-navy"></i>
				</CustomIconButton>
				<CustomIconButton
					variant="delete"
					onClick={() => {
						rowSelectedRef.current = props.row.original;
						setOpenCofirmDeleteDialog(true);
					}}
				>
					<i className="bi bi-trash3-fill text-danger"></i>
				</CustomIconButton>
			</div>
		),
	};

	const updateRowData = (rowIndex: number, field: string, value: any) => {
		const tableDataTemp = [...vatTuChecked];
		const rowUpdate = tableDataTemp.find((row: any, index: number) => index === rowIndex);
		const editedValue = getCellEditValue({
			rowUpdate,
			field,
			value,
			categories,
			patientInfo: benhNhanDieuTri,
		});
		const updatedList = tableDataTemp.map((row: any, index) => {
			if (index === rowIndex) {
				return {
				...row,
				...editedValue,
				};
			}
			return row;
		});
		setVatTuChecked(updatedList);
  	};
 
	return (
		<div className="d-flex flex-column flex-grow-1 mt-2 bg-white">
			<div className="d-flex spaces pt-10 px-10 pb-6 text-pri fw-bold">Phiếu chỉ định</div>
			<div className="flex-grow-1 spaces h-calc-vh-710">
				<TableCustom
					columns={columnsPhieuChiDinhKeVatTu}
					data={vatTuChecked}
					height={220}
					maxHeight={220}
					columnsActions={columnsActions}
					tableOptions={{
						updateRowData,
						objectTypes: categories.listDoiTuong,
					}}
				/>
			</div>

			{openCofirmDeleteDialog && (
				<ConfirmDialog
					className="z-index-1060"
					show={openCofirmDeleteDialog}
					title="Thông báo"
					message="Bạn có chắc chắn muốn xóa vật tư này không ?"
					yes="Xác nhận"
					close="Đóng"
					onCloseClick={() => {
						setOpenCofirmDeleteDialog(false);
						rowSelectedRef.current = null;
					}}
					onYesClick={onDeleteVatTu}
				/>
			)}
		</div>
	);
};

export default TablePhieuChiDinhVatTu;
